import { useEffect, useState } from 'react';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import { useI18n } from '@i18n/useI18n';
import { GridCard } from '@components/GridCards/Common.styled';
import RewardItem from '../RewardItem';
import {
  CDiv,
  CreateBox,
  CustomBox,
  DD,
  DDItem,
  DDPreview,
  DateBox,
  IconDDL,
  NavButton,
  PreviewBox,
  Title,
  DeleteBox,
} from './AddReward.styled';
import Rewards from '@models/Rewards';
import Chevron_Icon from '@assets/svg/chevron-down.svg';
import DatePick from '@components/Buttons/DatePick';
import moment from 'moment';
import Toggle from '@components/Buttons/Toggle';
import Cross_Icon from '@assets/svg/match/missing.svg';
import { BoxTop, Popup, PopupBox } from '@components/Redeem/Redeembackup.styled';

interface IProps {
  setNav: (number) => void;
  getRewards: () => void;
  editItem?: any;
}

const AddReward = (props: IProps) => {
  const i18n = useI18n();
  const { callNameSetting, adminSelection, adminSelectedStudent, clientSettings, systemSettings, client } = useStore();
  const [DDActive, setDDActive] = useState(false);
  const [infiniteUses, setInfiniteUses] = useState(false);
  const [infiniteLimit, setInfiniteLimit] = useState(false);
  const [noDateLimit, setNoDateLimit] = useState(false);
  const [active, setActive] = useState(true);
  const [fromDate, setFromDate] = useState(moment());
  const [toDate, setToDate] = useState(moment().add(7, 'days'));
  const [showDelete, setShowDelete] = useState(false);
  const [reward, setReward] = useState({
    id: null,
    title: null,
    description: null,
    icon: 0,
    cost: null,
    limit: null,
    active: true,
    stock: null,
  });
  let language = systemSettings.find((s) => s.APP_Setting_ID === 16);
  useEffect(() => {
    if (props.editItem) {
      let item = JSON.parse(JSON.stringify(props.editItem));
      if (props.editItem.todate === null && props.editItem.fromdate === null) setNoDateLimit(true);
      else {
        if (props.editItem.todate !== null) setToDate(moment(props.editItem.todate));
        if (props.editItem.fromdate !== null) setFromDate(moment(props.editItem.fromdate));
      }
      if (props.editItem.stock === -1) {
        setInfiniteUses(true);
      }
      if (props.editItem.limit === -1) setInfiniteLimit(true);
      if (props.editItem.active === false) setActive(false);
      setReward(item);
    }
  }, []);

  const handleInput = (e, type) => {
    let item = JSON.parse(JSON.stringify(reward));
    switch (type) {
      case 1:
        item.title = e.target.value;
        break;
      case 2:
        item.description = e.target.value;
        break;
      case 3:
        item.icon = e;
        break;
      case 4:
        if (isNaN(e.target.value)) return;
        item.cost = e.target.value;
        break;
      case 5:
        if (isNaN(e.target.value)) return;
        item.stock = e.target.value;
        break;
      case 6:
        if (isNaN(e.target.value)) return;
        item.limit = e.target.value;
        break;
    }
    setReward(item);
  };

  const HandleSelectedFilterDate = (e, type) => {
    switch (type) {
      case 1:
        setFromDate(moment(e));
        break;
      case 2:
        setToDate(moment(e));
        break;
    }
  };

  const addReward = async () => {
    let item = getRewardItem();
    item = Object.assign(item, { fromdate: fromDate.format('YYYY-MM-DD'), todate: toDate.format('YYYY-MM-DD') });
    if (infiniteUses) item.stock = -1;
    if (noDateLimit) {
      item.todate = null;
      item.fromdate = null;
    }
    if (item.cost === null || '') item.cost = 0;
    await db.Modify_Reward(
      item.id,
      item.title,
      item.description,
      item.fromdate,
      item.todate,
      item.icon,
      item.cost,
      item.limit,
      active,
      item.stock,
      language.value,
      client.UserName,
    );
    await props.getRewards();
    props.setNav(0);
  };

  const addRewardDisabled = () => {
    let title = reward.title === null || reward.title === undefined || reward.title === '';
    let description = reward.description === null || reward.description === undefined || reward.description === '';
    let cost = reward.cost === null || reward.cost === undefined || reward.cost === '' || isNaN(reward.cost);
    let limit =
      infiniteLimit === false && (reward.limit === null || reward.limit === undefined || reward.limit === '' || isNaN(reward.limit));
    let stock =
      infiniteUses === false && (reward.stock === null || reward.stock === undefined || reward.stock === '' || isNaN(reward.stock));
    return cost || limit || stock || title || description;
  };

  const getRewardItem = () => {
    let item = JSON.parse(JSON.stringify(reward));
    if (infiniteLimit) item.limit = -1;
    if (infiniteUses) item.stock = -1;
    return item;
  };

  const upperCaseFirstLetter = (text) => {
    return text.charAt(0).toUpperCase() + text.substring(1).toLowerCase();
  };

  const deleteReward = async () => {
    await db.Delete_Reward(reward.id);
    setShowDelete(false);
    await props.getRewards();
    props.setNav(0);
  };

  let Icon = Rewards[reward.icon].icon;

  return (
    <>
      <Popup show={showDelete}>
        <PopupBox>
          <BoxTop>
            <span>{i18n.t('confirm')}</span>
            <button onClick={() => setShowDelete(false)}>
              <Cross_Icon />
            </button>
          </BoxTop>
          <span></span>
          <p>{i18n.t('delete-reward-text')}</p>
          <div>
            <button onClick={() => setShowDelete(false)}>{i18n.t('note-cancel')}</button>
            <button onClick={deleteReward}>{i18n.t('ok')}</button>
          </div>
        </PopupBox>
      </Popup>

      <GridCard col={1} heightAuto={true}>
        
        <Title>{props.editItem ? i18n.t('edit-reward') : i18n.t('create-reward')}</Title>
        <CustomBox>
          <span>{active ? i18n.t('reward-active') : i18n.t('reward-inactive')}</span>
          <Toggle selected={active} onChange={setActive} />
        </CustomBox>
        <CreateBox>
          <span>{i18n.t('title')}</span>
          <input maxLength={25} onChange={(e) => handleInput(e, 1)} placeholder={ i18n.t('title') + " (" + i18n.t('max-length', {count:25}) + ")"} value={reward.title || ''} />
        </CreateBox>
        <CreateBox>
          <span>{i18n.t('description')}</span>
          <textarea maxLength={90} onChange={(e) => handleInput(e, 2)} placeholder={i18n.t('reward-description-placeholder', {count:90})} value={reward.description || ''} />
        </CreateBox>
        <CreateBox>
          <span>{i18n.t('select-icon')}</span>
          <IconDDL height={DDActive}>
            <DDPreview onClick={() => setDDActive(!DDActive)}>
              <span>{reward.icon !== null ? <Icon /> : i18n.t('select-icon')}</span>
              <Chevron_Icon />
            </DDPreview>
            <DD>
              {Rewards.map((i, index) => (
                <DDItem key={index} onClick={() => handleInput(index, 3)}>{<i.icon />}</DDItem>
              ))}
            </DD>
          </IconDDL>
        </CreateBox>
        <CreateBox>
          <span>{i18n.t('no-date-limit')}</span>
          <Toggle selected={noDateLimit} onChange={setNoDateLimit} />
        </CreateBox>
        <CreateBox disable={noDateLimit}>
          <DateBox>
            <div>
              <p>{upperCaseFirstLetter(i18n.t('from'))}</p>
              <DatePick
                date={fromDate}
                max={toDate.clone().add(-1, 'days')}
                handleOnChange={HandleSelectedFilterDate}
                type={1}
                isActive={false}
              />
            </div>
            <div>
              <p>{upperCaseFirstLetter(i18n.t('to'))}</p>
              <DatePick
                min={fromDate.clone().add(1, 'days')}
                date={toDate}
                handleOnChange={HandleSelectedFilterDate}
                type={2}
                isActive={false}
              />
            </div>
          </DateBox>
        </CreateBox>
        <CreateBox>
          <span>{i18n.t('reward-cost')}</span>
          <input onChange={(e) => handleInput(e, 4)} placeholder={i18n.t('reward-cost-placeholder')} value={reward.cost || ''} />
        </CreateBox>
        <CreateBox>
          <span>{i18n.t('enable-infinite-cost')}</span>
          <Toggle selected={infiniteUses} onChange={setInfiniteUses} />
        </CreateBox>
        <CreateBox disable={infiniteUses}>
          <span>{i18n.t('stock')}</span>
          <input onChange={(e) => handleInput(e, 5)} placeholder={i18n.t('stock-placeholder')} value={reward.stock === -1 ? '' : reward.stock || ''} />
        </CreateBox>
        <CreateBox>
          <span>{i18n.t('enable-infinite-limit')}</span>
          <Toggle selected={infiniteLimit} onChange={setInfiniteLimit} />
        </CreateBox>
        <CreateBox disable={infiniteLimit}>
          <span>{i18n.t('purchase-limit')}</span>
          <input
            onChange={(e) => handleInput(e, 6)}
            placeholder={i18n.t('purchase-limit-placeholder')}
            value={reward.limit === -1 ? '' : reward.limit || ''}
          />
        </CreateBox>
        <CreateBox>
          <DateBox>
            <NavButton onClick={() => props.setNav(0)}>{i18n.t('cancel')}</NavButton>
            {props.editItem ? (
              <NavButton red={true} onClick={() => setShowDelete(true)}>
                {i18n.t('delete-reward')}
              </NavButton>
            ) : null}
            <NavButton disabled={addRewardDisabled()} onClick={addReward}>
              {i18n.t('save')}
            </NavButton>
          </DateBox>
        </CreateBox>
      </GridCard>

      <GridCard col={1} heightAuto={true}>
        <Title>{i18n.t('preview-reward')}</Title>

        <CDiv>
          <PreviewBox>
            <span>{i18n.t('preview-normal')}</span>
            <RewardItem rewardItem={getRewardItem()} previewState={1} />
          </PreviewBox>

          <PreviewBox>
            <span>{i18n.t('preview-grayed')}</span>
            <RewardItem rewardItem={getRewardItem()} previewState={2} />
          </PreviewBox>
        </CDiv>
      </GridCard>
    </>
  );
};

export default AddReward;
